import PropTypes from 'prop-types'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { AmenitySearch, filterAmenitiesByName } from '../../AmenitySearch'
import AmenityItem from '../../AmenityItem/AmenityItem'

const SelectAmenity = ({
  onBack = () => {},
  onNext = () => {},
  handleSelectAmenity = () => {},
  isLoadingAmenities,
  title,
  canGoNext,
  amenities,
  selectedAmenity,
  style,
}) => {
  const { t } = useTranslation(['reservations', 'common'])
  const [searchQuery, setSearchQuery] = useState('')
  const filteredAmenities = filterAmenitiesByName(amenities, searchQuery)
  return (
    <div className={isLoadingAmenities ? 'is-loading' : ''}>
      <div className="reservations-modal-content reservations-add-time-block-modal" style={style}>
        <div className="select-amenity-header">
          <span className="title">{title}</span>
          <AmenitySearch onSearch={setSearchQuery} />
        </div>
        <div className="selectAmenityView">
          <div className="amenities">
            {filteredAmenities.length ? (
              filteredAmenities.map((amenity) => (
                <AmenityItem
                  key={amenity.id}
                  amenity={amenity}
                  isSelected={selectedAmenity && amenity.id === selectedAmenity.id}
                  onClick={handleSelectAmenity}
                />
              ))
            ) : (
              <div>
                {amenities.length
                  ? t('reservations:amenitySearch.noResults')
                  : t('reservations:reservationForClientForm.noAmenitiesAvailable')}
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="reservations-modal-actions">
        <button className="button button-gray" onClick={onBack}>
          {t('common:actions.back')}
        </button>
        <button className="button button-primary" disabled={!canGoNext} onClick={onNext}>
          {t('reservations:shared.next')}
        </button>
      </div>
    </div>
  )
}

SelectAmenity.propTypes = {
  onBack: PropTypes.func,
  onNext: PropTypes.func,
  handleSelectAmenity: PropTypes.func,
  title: PropTypes.string,
  amenities: PropTypes.array,
  canGoNext: PropTypes.bool,
  isLoadingAmenities: PropTypes.bool,
  selectedAmenity: PropTypes.object,
  style: PropTypes.object,
}

export default SelectAmenity
